export const GET_ROSS1000_STRUTTURE = 'GET_ROSS1000_STRUTTURE';
export const GET_ROSS1000_COMUNI = 'GET_ROSS1000_COMUNI';
